<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Pesquisa </mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <form-search-purchase-reservation-tg (responseSearch)="search($event)" />
    </div>
  </mat-expansion-panel>
</mat-accordion>

<div class="mt-6">
  @if (!loading) {
    <div>
      <table-list-purchase-reservation-tg
        [dataSource]="itemsList"
        [columns]="columns"
        (viewItem)="viewItem($event)"
      />
      @if (itemsList.length > 0) {
        <mat-paginator
          [length]="numberRows"
          [pageSize]="rows"
          [pageIndex]="page - 1"
          [pageSizeOptions]="[5, 10, 20, 30]"
          (page)="onPageEvent($event)"
        >
        </mat-paginator>
      }
    </div>
  } @else {
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
</div>
